import React from "react";

export default function TermsPage() {
  return (
    <div style={{ fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif", color: "#1a1a1a", background: "#fafaf8", minHeight: "100vh", padding: "24px 16px 48px" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Serif+Display&display=swap" rel="stylesheet" />
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <a href="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#2d5a27", fontWeight: 600, fontSize: 14, textDecoration: "none", marginBottom: 32 }}>
          ← Back to home
        </a>
        <h1 style={{ fontSize: 32, fontWeight: 700, fontFamily: "'DM Serif Display', serif", margin: "0 0 8px", color: "#1a1f16" }}>Terms of Service</h1>
        <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 32px" }}>Last updated: {new Date().toLocaleDateString("en-US")}</p>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>1. Acceptance of Terms</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            By accessing or using Ingrediable, you agree to be bound by these Terms of Service. If you do not agree, do not use the service.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>2. Description of Service</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            Ingrediable provides a kitchen inventory, shopping list, expiry alerts, and waste-tracking service. We strive to keep the service available and accurate but do not guarantee uninterrupted or error-free operation.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>3. Your Account and Conduct</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: "0 0 12px" }}>
            You are responsible for maintaining the confidentiality of your account and for all activity under your account. You agree to use the service only for lawful purposes and not to misuse, disrupt, or attempt to gain unauthorized access to our systems or other users&apos; data.
          </p>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            You must be at least 13 years old (or the minimum age in your jurisdiction) to use Ingrediable.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>4. Intellectual Property</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            The service, including its design, features, and content (excluding user-generated content), is owned by Ingrediable and protected by intellectual property laws. You may not copy, modify, or create derivative works without our permission.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>5. Disclaimer of Warranties</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            The service is provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind, express or implied. We do not warrant that the service will be uninterrupted, secure, or free of errors. Use of expiry dates, alerts, and recommendations is at your own discretion; we are not liable for food safety or consumption decisions.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>6. Limitation of Liability</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            To the maximum extent permitted by law, Ingrediable and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of data, profits, or revenue, arising from your use of the service.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>7. Changes and Termination</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            We may modify these terms at any time; we will notify you of material changes (e.g., via email or in-app notice). Continued use after changes constitutes acceptance. We may suspend or terminate your access for violation of these terms or for any other reason.
          </p>
        </section>

        <section style={{ marginBottom: 28 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 12px", color: "#1a1f16" }}>8. Contact</h2>
          <p style={{ fontSize: 15, lineHeight: 1.7, color: "#374151", margin: 0 }}>
            For questions about these terms, contact us at <a href="mailto:legal@ingrediable.com" style={{ color: "#2d5a27", fontWeight: 600 }}>legal@ingrediable.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
